import {AbstractUaService, UaType} from './abstract-ua-service';
import {Injectable} from '@angular/core';
import {ApiService} from './api';
import { map, of } from 'rxjs';
import { environment } from '@hub-env/environment';
import { Partner } from './partner';

@Injectable({providedIn: 'root'})
export class UmsService {
  constructor(protected apiService: ApiService) { }

    getAllUsersFromUMS() {
        return this.apiService.get(`/api/v2/ums/users`).pipe(map((response: any) => response.data));
    }
    sendUmsInviteEmail(id: string) {
        return this.apiService.post(`/api/v2/ums/users/${id}/invite`, {umsInviteDetails: environment.umsInviteDetails});
    }
    getOrgUsersFromUMS(partner: Partner) {
        const orgCode = partner.carrier_code || partner.channel_code;
        if(!orgCode) {
            console.log('No org code found for partner', {
                name: partner?.name,
                channel_code: partner?.channel_code,
                carrier_code: partner?.carrier_code,
                id: partner?.id
            });
        }
        return this.apiService.get(`/api/v2/ums/users?custom-attributes=org_code:${orgCode}`).pipe(map((response: any) => response.data));
    }
}